import type { DefaultTheme } from 'styled-components';

export const WINDOW_RADIUS = '16px';

export const windowSurfaceOf = ({ colors, isLightTheme }: DefaultTheme): string =>
  (isLightTheme ? colors.surfaceContainerHigh : colors.surfaceContainerLow) ?? colors.surface;
